/* istanbul ignore file */
import { array as codecArray } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
import { _SubmissionRubricItemDataParser } from './_SubmissionRubricItemDataParser';
const PutRubricResultSubmissionDataParser = 
/* #__PURE__ */ parsers.object([
    ['items', /* #__PURE__ */ codecArray(_SubmissionRubricItemDataParser)],
]);
export class PutRubricResultSubmissionData extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return PutRubricResultSubmissionDataParser.decode(input).map(res => new PutRubricResultSubmissionData(res));
    }
    static unsafeDecode(input) {
        return PutRubricResultSubmissionData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return PutRubricResultSubmissionDataParser.encode(data);
    }
    static schema() {
        return PutRubricResultSubmissionDataParser.schema();
    }
}
